/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_Tlm_0Inputs */

const en_svc_messaging_bots_tlm_0 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`channels`)
};

const ar_svc_messaging_bots_tlm_0 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`القنوات`)
};

const bn_svc_messaging_bots_tlm_0 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`চ্যানেল`)
};

const de_svc_messaging_bots_tlm_0 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanäle`)
};

const es_svc_messaging_bots_tlm_0 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canales`)
};

const fr_svc_messaging_bots_tlm_0 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canaux`)
};

const pt_svc_messaging_bots_tlm_0 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canais`)
};

const zh_svc_messaging_bots_tlm_0 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`渠道`)
};

const tr_svc_messaging_bots_tlm_0 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanallar`)
};

const ru_svc_messaging_bots_tlm_0 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Каналы`)
};

const pl_svc_messaging_bots_tlm_0 = /** @type {(inputs: Svc_Messaging_Bots_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanały`)
};

/**
* | output |
* | --- |
* | "channels" |
*
* @param {Svc_Messaging_Bots_Tlm_0Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_tlm_0 = /** @type {((inputs?: Svc_Messaging_Bots_Tlm_0Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_Tlm_0Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_tlm_0(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_tlm_0(inputs)
	if (locale === "de") return de_svc_messaging_bots_tlm_0(inputs)
	if (locale === "es") return es_svc_messaging_bots_tlm_0(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_tlm_0(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_tlm_0(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_tlm_0(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_tlm_0(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_tlm_0(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_tlm_0(inputs)
	return en_svc_messaging_bots_tlm_0(inputs)
});
export { svc_messaging_bots_tlm_0 as "svc_messaging-bots_tlm_0" }